import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, Instagram } from 'lucide-react';
export function FounderSection() {
  return <section id="fundadora" className="py-24 bg-inkova-light" data-id="element-158">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-inkova-primary mb-4" data-id="element-161">
            La persona detrás de&nbsp;Inkova.
          </motion.h2>
          <div className="w-24 h-1 bg-inkova-accent mx-auto rounded-full" data-id="element-162"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-163">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-164">
            <div className="absolute -inset-4 bg-inkova-accent/20 rounded-3xl transform -rotate-3" data-id="element-165"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5f8VVQ8CW7sbUwuxLSKEgi/ddd61cf5-9214-43f7-a987-6957f92ed66c.jpg" alt="Annysol Navarro, Fundadora de Inkova" className="relative rounded-2xl shadow-xl w-full h-auto object-cover" data-id="element-166" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="prose prose-lg text-gray-700 font-sans" data-id="element-167">
            <div className="mb-8" data-id="element-168">
              <h3 className="text-3xl font-serif text-inkova-primary font-bold mb-1" data-id="element-169">
                Annysol Navarro
              </h3>
              <p className="text-inkova-accent font-medium text-lg uppercase tracking-wider" data-id="element-170">
                Fundadora · Inkova LLC
              </p>
            </div>

            <ul className="space-y-2 mb-8 text-sm md:text-base font-medium text-gray-800" data-id="element-171">
              <li className="flex items-center" data-id="element-172">
                <span className="w-1.5 h-1.5 bg-inkova-accent rounded-full mr-3 flex-shrink-0" data-id="element-173"></span>
                Comunicadora Social
              </li>
              <li className="flex items-center" data-id="element-174">
                <span className="w-1.5 h-1.5 bg-inkova-accent rounded-full mr-3 flex-shrink-0" data-id="element-175"></span>
                Especialista en Relaciones Públicas y&nbsp;Publicidad
              </li>
              <li className="flex items-center" data-id="element-176">
                <span className="w-1.5 h-1.5 bg-inkova-accent rounded-full mr-3 flex-shrink-0" data-id="element-177"></span>
                Diseñadora
              </li>
              <li className="flex items-center" data-id="element-178">
                <span className="w-1.5 h-1.5 bg-inkova-accent rounded-full mr-3 flex-shrink-0" data-id="element-179"></span>
                Notaria certificada en&nbsp;Florida
              </li>
              <li className="flex items-center" data-id="element-180">
                <span className="w-1.5 h-1.5 bg-inkova-accent rounded-full mr-3 flex-shrink-0" data-id="element-181"></span>
                Certificada en&nbsp;Bookkeeping
              </li>
              <li className="flex items-start" data-id="element-182">
                <span className="w-1.5 h-1.5 bg-inkova-accent rounded-full mr-3 mt-2 flex-shrink-0" data-id="element-183"></span>
                +8&nbsp;años acompañando emprendedores y&nbsp;negocios
                en&nbsp;EE.&thinsp;UU., incluyendo creación de&nbsp;empresas
                y&nbsp;manejo de&nbsp;cuentas de&nbsp;alto&nbsp;valor
              </li>
            </ul>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8 italic text-gray-600 space-y-4" data-id="element-184">
              <p data-id="element-185">
                "Inkova no nació de la teoría. Nació de empezar, equivocarse y
                volver&nbsp;a&nbsp;comenzar."
              </p>
              <p data-id="element-186">
                "Y de entender que el emprendedor latino merece más que una
                respuesta genérica&nbsp;en&nbsp;Google."
              </p>
              <p data-id="element-187">
                "Merece acompañamiento real. Merece claridad. Merece un negocio
                construido&nbsp;con&nbsp;base."
              </p>
              <p className="font-bold text-inkova-primary not-italic" data-id="element-188">
                Eso es lo que construimos&nbsp;en&nbsp;Inkova.
              </p>
            </div>

            <div className="space-y-3" data-id="element-189">
              <a href="https://wa.me/17863037695" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-600 hover:text-inkova-primary transition-colors" data-id="element-190">
                <MessageCircle className="w-5 h-5 text-inkova-accent mr-3" data-id="element-191" />
                WhatsApp: +1 (786) 303‑7695
              </a>
              <a href="mailto:inkovallc@gmail.com" className="flex items-center text-gray-600 hover:text-inkova-primary transition-colors" data-id="element-192">
                <Mail className="w-5 h-5 text-inkova-accent mr-3" data-id="element-193" />
                Email: inkovallc@gmail.com
              </a>
              <a href="https://instagram.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-600 hover:text-inkova-primary transition-colors" data-id="element-194">
                <Instagram className="w-5 h-5 text-inkova-accent mr-3" data-id="element-195" />
                Instagram: @inkovacreation
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}